import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/changes/license.content.decide.mutation.gql"
import type {
  FeatureContentDecideMutation,
  FeatureContentDecideMutationVariables,
} from "@/v2-backoffice-client/license/changes/__types__/license.content.decide.mutation"

type Options = MutationHookOptions<
  FeatureContentDecideMutation,
  FeatureContentDecideMutationVariables
>

export function useFeatureContentDecideMutation(options?: Options) {
  return useMutation<
    FeatureContentDecideMutation,
    FeatureContentDecideMutationVariables
  >(mutation, options)
}
